import {api_url, languages, upload_path} from "../../_AE/Helpers";

export const CONTEXT = "challenge";
export const API_URI = api_url+"/"+CONTEXT;
export const UPLOAD_PATH = upload_path+"/"+CONTEXT
export const SEARCHABLE = languages.map(l=>`name_${l}`).concat([]);
export const ROUTE_PREFIX = "/"+CONTEXT;
export const CONTEXT_TITLE = {
  singular: "Challenge",
  plural: "Challenges",
}
/**/


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    // enabled: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultEntity = {
  "name_fr": "",
  "name_en": "",
  "name_ar": "",
  "caption_fr": "",
  "caption_en": "",
  "caption_ar": "",
  "description_en": "",
  "description_ar": "",
  "description_fr": "",

  gender: "Both",
  rest_between_rounds: 60,
  beginner_price: 0,
  intermediate_price: 0,
  advanced_price: 0,
  days_numbers : 0,
  days:[],
  rounds:[],
  exercices:[],
  "enabled": true
};


